import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ReactQueryProvider } from '@/utils/ReactQuery';
import cn from '@/utils/cn';
import GradeSyncView from '../SysadminSPA/GradeSyncView';
import { GradeSyncBaseProvider } from '../SysadminSPA/GradeSyncView/gradeSyncPath';
import { SPAThemeScope } from '../SysadminSPA/shared/SPAThemeScope';
import { SPAUserProvider } from '../SysadminSPA/shared/SPAUser';

// AIDEV-NOTE: The SPA's grade sync page mounted on the legacy /admin/grade_sync page, the way
// admin/UserSearch is, for support managers who can't reach /sysadmin. The router is based at the
// legacy path, so GradeSyncBaseProvider empties grade sync's /support/grade-sync prefix; its child
// routes need `admin/grade_sync/*path` routed to #index (config/routes.rb) for deep links and reloads.
const THEME_CLASS = 'spa-theme-light';

const groundClasses = cn(
  THEME_CLASS,
  'tw-box-border tw-min-h-[calc(100vh-5.875rem)] tw-bg-spa-bg tw-text-spa-on-bg',
  'tw-shadow-[0_0_0_100vmax_var(--spa-bg)]',
);

// AIDEV-NOTE: Supplies what the SPA shell would. Without it useSPAUser falls back to its defaults, where
// canViewSyncLog is false — which hid the raw sync log here from Sysadmins too.
const GradeSyncHealth = ({ canViewSyncLog = false }: { canViewSyncLog?: boolean }) => (
  <ReactQueryProvider>
    <BrowserRouter basename="/admin/grade_sync">
      <SPAUserProvider value={{
        canManageContent: false, canManageSupport: true, canViewSyncLog, showPrintTools: false, showSearch: false,
      }}
      >
        <GradeSyncBaseProvider value="">
          <SPAThemeScope className={THEME_CLASS}>
            <div className={groundClasses} style={{ clipPath: 'inset(0 -100vmax)' }}>
              <GradeSyncView />
            </div>
          </SPAThemeScope>
        </GradeSyncBaseProvider>
      </SPAUserProvider>
    </BrowserRouter>
  </ReactQueryProvider>
);

export default GradeSyncHealth;
